"use client";

import { useTranslations } from "@i18n/provider";
import type { ConversationDifficulty } from "../types";
import { CONVERSATION_DIFFICULTIES } from "@lib/agent/conversation/types";

const OPTIONS = CONVERSATION_DIFFICULTIES;

const LABEL_KEYS: Record<ConversationDifficulty, string> = {
  easy: "agent.conversation.difficulty.easy",
  standard: "agent.conversation.difficulty.standard",
  stretch: "agent.conversation.difficulty.stretch",
};

type DifficultySelectorProps = {
  value: ConversationDifficulty;
  onChange: (value: ConversationDifficulty) => void;
  disabled?: boolean;
};

export function DifficultySelector({ value, onChange, disabled }: DifficultySelectorProps) {
  const { t } = useTranslations();

  return (
    <div className="mt-3">
      <p className="eyebrow mb-2 text-ink-faint">{t("agent.conversation.difficulty.label")}</p>
      <div
        className="inset-segment flex gap-3"
        role="group"
        aria-label={t("agent.conversation.difficulty.groupLabel")}
      >
        {OPTIONS.map((option) => {
          const active = value === option;
          return (
            <button
              key={option}
              type="button"
              aria-pressed={active}
              disabled={disabled}
              onClick={(event) => {
                event.stopPropagation();
                onChange(option);
              }}
              className={`min-h-[44px] flex-1 rounded-xl px-2 text-sm font-semibold transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-speaking ${
                active ? "inset-segment-active bg-speaking-tint text-speaking-fg" : "text-ink-muted"
              }`}
            >
              {t(LABEL_KEYS[option])}
            </button>
          );
        })}
      </div>
    </div>
  );
}
